export const locationApprovalQueryKeys = {
	all: ['location-access'],
	queue: ['location-access', 'queue'],
	userAccess: (userId: number) => ['location-access', userId],
} as const;
